import { FC, MouseEvent } from 'react';
import { ButtonGroup, ButtonBase } from '@mui/material';
import { SystemColors } from 'melp-design/style';
import { Close } from '@mui/icons-material';

interface Props {
  id?: string;
  label: string;
  isActive: boolean;
  onTrigger: (event: MouseEvent<HTMLButtonElement>) => void;
  onClear: () => void;
}

export const TriggerButton: FC<Props> = ({
  id,
  label,
  isActive,
  onTrigger,
  onClear,
}) => {
  return (
    <ButtonGroup
      aria-describedby={id}
      sx={{
        borderWidth: 1,
        borderStyle: 'solid',
        borderColor: SystemColors.grey[90],
        borderRadius: '6px',
        color: isActive ? SystemColors.black : SystemColors.grey[45],
        backgroundColor: SystemColors.white,
        transitionDuration: '150ms',
        fontWeight: 400,
        fontSize: 12,
        overflow: 'hidden',
        '&:hover': {
          borderColor: SystemColors.grey[75],
        },
      }}
    >
      <ButtonBase
        sx={{
          px: '10px',
          py: '5px',
          minWidth: 30,
          whiteSpace: 'nowrap',
          '&:hover': {
            backgroundColor: SystemColors.grey[98],
          },
        }}
        onClick={onTrigger}
      >
        {label}
      </ButtonBase>

      {isActive ? (
        <ButtonBase
          sx={{
            p: '5px',
            borderLeft: `1px solid ${SystemColors.grey[90]}`,
            '&:hover': {
              backgroundColor: SystemColors.grey[98],
            },
          }}
          onClick={() => onClear()}
        >
          <Close sx={{ fontSize: 16 }} />
        </ButtonBase>
      ) : null}
    </ButtonGroup>
  );
};
